var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-email-verify"},[_c('img',{staticClass:"email-verify-icon",attrs:{"src":require("@/assets/images/icon_email_verify_error.png"),"alt":""}}),_c('h1',{staticClass:"email-verify-tips"},[_vm._v(_vm._s(_vm.failTip))])])}
var staticRenderFns = []

export { render, staticRenderFns }